module.exports = __webpack_public_path__ + "img/baise.285638f2.png";